import { bus } from '../core/bus';
import { typhoonDay } from './weather';
import { apply, celebrate, onceToday, toast } from '../core/effects';
import { S } from '../core/game';
import { dayId, type DayId, type GameState } from '../core/state';
import { m } from '../i18n';

export interface DayDef {
  start: number;
  place: 'school' | 'home';
  objectives: readonly string[];
}

export const DAYS: Record<DayId, DayDef> = {
  fri: { start: 8 * 60, place: 'school', objectives: ['xiaoyu', 'teacher', 'log', 'homework'] },
  sat: { start: 9 * 60, place: 'home', objectives: ['cookies', 'picnic', 'dishes', 'sister'] },
  sun: { start: 9 * 60, place: 'home', objectives: ['strawberries', 'cake', 'giveCake', 'callDad'] },
};

/** Lights out: after this the bed ends the day; at FORCE_SLEEP the day ends anyway. */
export const BEDTIME = 20 * 60;
export const FORCE_SLEEP = 23 * 60;
export const ALL_GOALS_BONUS = 15;

export function objectiveText(day: DayId, key: string): string {
  return (m().objectives[day] as Record<string, string>)[key] ?? key;
}

export function isObjectiveDone(s: GameState, key: string): boolean {
  return !!s.daily[`obj.${key}`];
}

export function todaysObjectives(s: GameState = S()): { key: string; text: string; done: boolean }[] {
  const day = dayId(s);
  // On a typhoon day off there's no school: drop the school goals.
  const school = typhoonDay(s.dayIndex) ? ['xiaoyu', 'teacher', 'log'] : [];
  return DAYS[day].objectives.filter((key) => !school.includes(key)).map((key) => ({ key, text: objectiveText(day, key), done: isObjectiveDone(s, key) }));
}

/** Mark one of today's goals as done. Goals of other days are ignored. */
export function completeObjective(key: string): void {
  const s = S();
  const day = dayId(s);
  if (!DAYS[day].objectives.includes(key) || isObjectiveDone(s, key)) return;
  s.daily[`obj.${key}`] = true;
  toast(`✅ ${objectiveText(day, key)}`);
  bus.emit('objective', key);
  if (todaysObjectives(s).every((o) => o.done) && onceToday('allGoals')) {
    window.setTimeout(() => {
      apply({ stars: ALL_GOALS_BONUS });
      toast(m().objectives.bonus(ALL_GOALS_BONUS));
      celebrate(true);
    }, 900);
  }
  bus.emit('change');
}

/** First goal still open, for the task bar. */
export function currentObjective(s: GameState = S()): string | null {
  return todaysObjectives(s).find((o) => !o.done)?.text ?? null;
}
